import * as React from 'react';
import SmoothCollapse from 'react-smooth-collapse';

type AnimatedCollapsibleContentProps = {
    open:boolean,
    children:React.ReactNode,
    eagerRender?:boolean// Will cause the content to be rendered even when closed
}

export function AnimatedCollapsibleContent(props:AnimatedCollapsibleContentProps):JSX.Element
{

    return (
        <SmoothCollapse expanded={props.open} allowOverflowWhenOpen={true} eagerRender={props.eagerRender || false}>
            {props.children}
        </SmoothCollapse>
    );
}